import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { LOGIN } from "@/constants/testIds";

export default function Login() {
  const { setSession } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setSession(data);
      toast.success("¡Bienvenido de vuelta!");
      nav("/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream-50">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="font-heading text-4xl text-ink-900 font-light">Iniciar sesión</h1>
        <p className="mt-3 text-ink-500">Continúa organizando tus eventos.</p>

        <form onSubmit={submit} className="mt-10 space-y-6" data-testid="login-form">
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.2em] text-ink-500">Correo</Label>
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@correo.com"
              className="rounded-xl border-line focus:border-coral focus:ring-coral/20 h-12"
              data-testid={LOGIN.emailInput}
            />
          </div>
          <div className="space-y-2">
            <Label className="text-xs uppercase tracking-[0.2em] text-ink-500">Contraseña</Label>
            <Input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••"
              className="rounded-xl border-line focus:border-coral focus:ring-coral/20 h-12"
              data-testid={LOGIN.passwordInput}
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full bg-coral hover:bg-coral-hover text-white"
            data-testid={LOGIN.submitButton}
          >
            {loading ? "Entrando…" : "Entrar"}
          </Button>
        </form>

        <div className="mt-4 text-center">
          <Link to="/recuperar" className="text-sm text-ink-500 hover:text-coral" data-testid="forgot-password-link">
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        <p className="mt-8 text-sm text-ink-500 text-center">
          ¿No tienes cuenta?{" "}
          <Link to="/registro" className="text-coral hover:underline" data-testid={LOGIN.registerLink}>
            Regístrate gratis
          </Link>
        </p>
      </div>
    </div>
  );
}
